import React from "react";

import { AppState } from "store";
import { useSelector } from "react-redux";
import { Map } from "immutable";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

function useTodosByUrgency() {
  const { urgencyMap, itemMap } = useSelector((state: AppState) => state.todos);

  const todosByUrgency = React.useMemo(() => {
    const todos = urgencyMap?.map((t) => {
      const total = t.total;
      let items = t.items.map((k) => itemMap?.get(k));
      const fullyLoaded = total === items.count();
      if (!fullyLoaded) {
        items = items.setSize(total);
      }
      return { total, items: items.toArray(), fullyLoaded };
    });
    return (
      todos ??
      Map<
        WintSuperkollAPIModel.TodoUrgency,
        { total: number; items: WintSuperkollAPIModel.Todo[]; fullyLoaded: boolean }
      >()
    );
  }, [urgencyMap, itemMap]);

  return { todosByUrgency };
}

export default useTodosByUrgency;
